import FormattedMessage from 'I18n/components/FormattedMessage';
import UITag from 'UIComponents/tag/UITag';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { removeFromCompareProducts } from '../../actions/CompareActions';
import { ApiNameToProductTranslationKeyMap } from '../../constants/ApiNameToProductTranslationKeyMap';
import { getCompareApiNamesSelector } from '../../selectors/CompareSelectors';
import { productSelector } from '../../selectors/ProductsSelectors';
import ProductIcon from '../common/ProductIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompareTag = ({
  apiName
}) => {
  const dispatch = useDispatch();
  const compareApiNames = useSelector(getCompareApiNamesSelector, shallowEqual);
  const onCloseClick = () => {
    dispatch(removeFromCompareProducts(apiName));
    getUsageTracker().track('compareToolInteraction', {
      action: 'removed product',
      product: apiName,
      productNames: compareApiNames
    });
  };
  const {
    productLine
  } = useSelector(state => {
    return productSelector(state, {
      apiName
    });
  });
  return /*#__PURE__*/_jsxs(UITag, {
    closeable: true,
    className: "m-y-2 p-y-2",
    onCloseClick: onCloseClick,
    children: [/*#__PURE__*/_jsx(ProductIcon, {
      productLine: productLine,
      className: "display-inline m-right-2",
      width: 24
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: ApiNameToProductTranslationKeyMap[apiName]
    })]
  }, apiName);
};
export default CompareTag;